import { render, staticRenderFns } from "./fileModal.vue?vue&type=template&id=a0a4e3a4&scoped=true&"
import script from "./fileModal.vue?vue&type=script&lang=js&"
export * from "./fileModal.vue?vue&type=script&lang=js&"
import style0 from "./fileModal.vue?vue&type=style&index=0&id=a0a4e3a4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a4e3a4",
  null
  
)

export default component.exports